<template>
  <div
    class="flex flex-row items-end justify-center w-full lg:w-1/2 h-full p-2 lg:p-4"
  >
    <!-- Second Position -->
    <div
      class="relative flex flex-col items-center justify-end h-full"
      v-if="bestConsultants[1]"
    >
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center"
        :style="{
          backgroundColor: bestConsultants[1].profileUrl
            ? 'transparent'
            : getRandomDarkColor(),
          color: 'white',
        }"
      >
        <img
          v-if="bestConsultants[1].profileUrl"
          :src="bestConsultants[1].profileUrl"
          :alt="bestConsultants[1].nome"
          class="rounded-full w-12 h-12 md:w-20 md:h-20"
        />
        <span v-else class="text-lg font-medium">{{
          getInitials(bestConsultants[1].nome)
        }}</span>
      </div>
      <span class="text-xs md:text-sm font-semibold mb-2">{{
        bestConsultants[1].nome
      }}</span>
      <span
        class="text-green text-center"
        v-html="getFormattedText(bestConsultants[1])"
      ></span>
      <div
        class="podium widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 rounded-l-lg flex flex-col items-center justify-between mt-8 py-4 bg-podium-second"
      >
        <div
          class="flex items-center justify-center rounded-full p-2 border-silver"
        >
          <AwardIcon style="width: 24px; height: 24px" class="silver" />
        </div>
        <span class="text-white text-2xl font-bold">2°</span>
      </div>
    </div>

    <!-- First Position -->
    <div
      class="relative flex flex-col items-center justify-end h-full"
      v-if="bestConsultants[0]"
    >
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center"
        :style="{
          backgroundColor: bestConsultants[0].profileUrl
            ? 'transparent'
            : getRandomDarkColor(),
          color: 'white',
        }"
      >
        <img
          v-if="bestConsultants[0].profileUrl"
          :src="bestConsultants[0].profileUrl"
          :alt="bestConsultants[0].nome"
          class="rounded-full w-12 h-12 md:w-20 md:h-20"
        />
        <span v-else class="text-lg font-medium">{{
          getInitials(bestConsultants[0].nome)
        }}</span>
      </div>
      <span class="text-xs md:text-sm font-semibold mb-2">{{
        bestConsultants[0].nome
      }}</span>
      <span
        class="text-green text-center"
        v-html="getFormattedText(bestConsultants[0])"
      ></span>
      <div
        class="podium widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 rounded-t-lg flex flex-col items-center justify-between mt-8 py-4 bg-podium-first"
      >
        <div
          class="flex items-center justify-center rounded-full p-2 border-golden"
        >
          <AwardIcon style="width: 24px; height: 24px" class="golden" />
        </div>
        <span class="text-white text-2xl font-bold">1°</span>
      </div>
    </div>

    <!-- Third Position -->
    <div
      class="relative flex flex-col items-center justify-end h-full"
      v-if="bestConsultants[2]"
    >
      <div
        class="rounded-full w-12 h-12 md:w-20 md:h-20 mb-2 flex items-center justify-center"
        :style="{
          backgroundColor: bestConsultants[2].profileUrl
            ? 'transparent'
            : getRandomDarkColor(),
          color: 'white',
        }"
      >
        <img
          v-if="bestConsultants[2].profileUrl"
          :src="bestConsultants[2].profileUrl"
          :alt="bestConsultants[2].nome"
          class="rounded-full w-12 h-12 md:w-20 md:h-20"
        />
        <span v-else class="text-lg font-medium">{{
          getInitials(bestConsultants[2].nome)
        }}</span>
      </div>
      <span class="text-xs md:text-sm font-semibold mb-2">{{
        bestConsultants[2].nome
      }}</span>
      <span
        class="text-green text-center"
        v-html="getFormattedText(bestConsultants[2])"
      ></span>
      <div
        class="podium widthPodiumMobile md:w-52 lg:w-40 xl:w-52 xxl:w-64 custom-rounded-r flex flex-col items-center justify-between mt-8 py-4 bg-podium-third"
      >
        <div
          class="flex items-center justify-center rounded-full p-2 border-bronze"
        >
          <AwardIcon style="width: 24px; height: 24px" class="bronze" />
        </div>
        <span class="text-white text-2xl font-bold">3°</span>
      </div>
    </div>
  </div>
</template>

<script>
import { AwardIcon } from 'vue-feather-icons';

export default {
  name: 'PlacementPodium',
  props: {
    isPresentationMode: Boolean,
    bestConsultants: Array,
    rankingCriteria: String,
  },
  components: {
    AwardIcon,
  },
  methods: {
    getInitials(name) {
      const initials = name
        .split(' ')
        .map((n) => n[0])
        .join('');
      return initials.toUpperCase().slice(0, 2);
    },
    getRandomDarkColor() {
      const colors = ['#2c3e50', '#34495e', '#2d3436', '#1e272e', '#3c6382'];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    getFormattedText(consultant) {
      return `<span class="text-sm md:text-lg font-bold block">${
        this.rankingCriteria === 'TotalVendas'
          ? `${consultant.totalVendas} Vendas`
          : consultant.valorPrimeiraParcela
      }</span>
          <span class="text-xs md:text-sm font-semibold">${
            this.rankingCriteria === 'TotalVendas'
              ? consultant.valorPrimeiraParcela
              : `${consultant.totalVendas} Vendas`
          }</span>`;
    },
  },
};
</script>

<style scoped>
.podium {
  height: auto;
}

.widthPodiumMobile {
  width: 25vw;
}

.bg-podium-first {
  min-height: 480px;
  background-color: #114880;
}

.bg-podium-second {
  min-height: 380px;
  background-color: #7091b3;
}

.bg-podium-third {
  min-height: 300px;
  background-color: #cfdae6;
}

.golden {
  color: #e6b932;
}

.border-golden {
  border: 1px solid #e6b932;
}

.silver {
  color: #d5d5d5;
}

.border-silver {
  border: 1px solid #d5d5d5;
}

.bronze {
  color: #af8c24;
}

.border-bronze {
  border: 1px solid #af8c24;
}

.text-green {
  color: #12cc68;
}

.custom-rounded-l {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.custom-rounded-r {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}
</style>
